import { render, staticRenderFns } from "./EditUserPage.vue?vue&type=template&id=077045c2&scoped=true"
import script from "./EditUserPage.vue?vue&type=script&lang=ts"
export * from "./EditUserPage.vue?vue&type=script&lang=ts"
import style0 from "./EditUserPage.vue?vue&type=style&index=0&id=077045c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077045c2",
  null
  
)

export default component.exports